import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jsonAxios } from 'components/axios';
import First from 'components/issue/list/First';
import { ReactComponent as Nodata } from 'assets/issue/nodata.svg'
import { ISearchInfo } from 'types/issue';
import MyPageTemplate from 'components/template/MyPageTemplate';
import { toast } from 'react-toastify';

const IssueList = () => {
    interface IIssue {
        id: number,
        title: string,
        blNo: string,
        createAt: string
        hasUnconfirmed: boolean
    }

    const navigate = useNavigate();
    const [list, setList] = useState<IIssue[]>([]);
    const [searchInfo, setSearchInfo] = useState<ISearchInfo>({
        fromDate: '',
        toDate: '',
        search: '',
        pageSize: 10,
        page: 1,
    });

    const queryParams = new URLSearchParams(window.location.search)
    const id = queryParams.get('id')
    const [blNo, setBlNo] = useState<string>('');

    const init = useCallback(() => {
        if (!id) {
            toast.error('잘못된 경로입니다.');
            setTimeout(() => {
                navigate(-1);
            }, 500);
            return;
        }

        const params = new URLSearchParams(Object.entries(searchInfo)).toString();
        jsonAxios.get(`issue/users?orderId=${id}&${params}`).then(res => {
            if (res.data.code === 200) {
                setList(res.data.data)
                setBlNo(res.data.blNo)
            }
        })
    }, [searchInfo, id]);

    useEffect(() => {
        init();
    }, [init]);

    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className="flex flex-col gap-10 tablet:gap-4 mb-6 py-10 tablet:py-4 h-full min-h-dvh">
                <First
                    title='이슈 검색'
                    searchInfo={searchInfo}
                    setSearchInfo={setSearchInfo}
                    init={init}
                    blNo={blNo}
                />
                <div className='flex flex-col gap-6'>
                    {
                        list.length > 0 ?
                            list.map((item, idx) => (
                                <div
                                    className={`group flex items-center text-sm bg-white rounded-xl cursor-pointer p-10 gap-10 h-[260px] hover:shadow-md transition-all tablet:flex-col tablet:p-4 tablet:h-auto tablet:gap-4`}
                                    key={idx}
                                    onClick={() => {
                                        navigate(`/mypage/issue/detail?id=${item.id}`)
                                    }}
                                >
                                    <div className='relative flex flex-col justify-center tablet:justify-start h-full tablet:h-auto shrink-0'>
                                        {
                                            item.hasUnconfirmed &&
                                            <div className='top-0 left-0 absolute bg-red px-2.5 py-1.5 rounded-full font-semibold text-white text-xs'>NEW</div>
                                        }
                                        <p className='text-[#9D9EB7]'>
                                            이슈발생일
                                        </p>
                                        <p className='font-semibold text-lg'>
                                            {item.createAt}
                                        </p>
                                    </div>

                                    <div className='w-[180px] h-[180px] overflow-hidden shrink-0'>
                                        <div className='flex justify-center items-center bg-[#f8f8fa] rounded w-full h-full'>
                                            <Nodata />
                                        </div>
                                        {/* <img
                                            className='rounded w-full h-full object-cover'
                                            src="https://img9.yna.co.kr/photo/etc/epa/2025/06/11/PEP20250611159401009_P4.jpg"
                                            alt=""
                                        /> */}
                                    </div>

                                    <div className={`flex flex-col justify-between items-center w-full h-full text-lg`}>
                                        <div className='flex items-center gap-1 w-full'>
                                            <div className='flex-[1] leading-none'>
                                                <p className='text-[#9D9EB7]'>BL no.</p>
                                                <p className='font-semibold'>{item.blNo}</p>
                                            </div>
                                            <div className='flex-[4] leading-none'>
                                                <p className='text-[#9D9EB7]'>이슈타이틀</p>
                                                <p className='font-semibold'>{item.title}</p>
                                            </div>
                                        </div>
                                        <div className='tablet:hidden flex items-center gap-1 w-full'>

                                        </div>
                                    </div>

                                </div>
                            ))
                            :
                            <div className='flex justify-center items-center py-6 min-h-[30vh]'>
                                데이터가 없습니다.
                            </div>
                    }
                </div>
            </div>
        </MyPageTemplate>
    )
}

export default IssueList